import { PageLayout } from '../components/shared';

import routesConfig from './routesConfig';
import routesContext from './routesContext';
import RoutesRenderer from './RoutesRenderer';

const Routes = (): JSX.Element => {
  return (
    <PageLayout>
      <RoutesRenderer {...{ routesContext, routesConfig }} />
    </PageLayout>
  );
};

export default Routes;
